import { takeLatest, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";

import { getPath } from "../../../utils";
import HttpService from "../../../services/HttpService";

import { proccessQrCodeLoginRequest, doTokenLoginRequest, generateQrCodeSuccess } from "./actions";

export function* generateQrCode() {
	try {
		let response = yield HttpService.getAuthToken();
		var auth_token = "";

		if (response.success) {
			auth_token = response.result;
		} else throw Error("Erro ao tentar pegar o código QR Code.");

		yield put(generateQrCodeSuccess(auth_token));
	} catch (err) {
		toast.error("Não foi possível gerar o QR Code.");
	}
}

export function* verifyProcess({ payload }) {
	try {
		const { auth_token } = payload;
		let response = yield HttpService.getAccessToken(auth_token);
		if (response.success && response.result) {
			const { result } = response;
			yield put(proccessQrCodeLoginRequest(result));
		}
	} catch (err) {
		toast.error("Não foi possivel verificar token de login.");
	}
}

export function* proccessQrCodeLogin({ payload }) {
	try {
		const { access_token } = payload;
		var response = yield HttpService.getSessionToken(access_token);
		if (response.success) {
			const token = response.result;
			yield put(doTokenLoginRequest(token));
		}
	} catch (err) {
		toast.error("Não foi possivel efetuar o login via QR Code.");
	}
}

export function* doTokenLogin({ payload }) {
	try {
		const { token } = payload;
		let response = yield HttpService.tokenLoginTM(token);
		if (response.success) {
			const { investor, multiBroker, billingStatus } = response.result;
			investor["type"] = "FREE";
			if (localStorage.getItem("CLIENT_AUTH")) {
				localStorage.removeItem("CLIENT_AUTH");
			}
			sessionStorage.setItem("CLIENT_AUTH", JSON.stringify(investor));
			sessionStorage.setItem("HAS_MULTIBROKER", multiBroker.length);
			sessionStorage.setItem("TOKEN", investor.token);
			sessionStorage.setItem("PACK", JSON.stringify(billingStatus));
			sessionStorage.setItem("IDKEY", investor.id_investor.toString());
			const homePortalPath = "/carregando-portal/" + investor.token;
			let path = !investor.is_password_defined ? "/redefinir-senha" : homePortalPath;

			if (
				investor.is_password_defined &&
				localStorage.getItem("IDLEAGUE") &&
				localStorage.getItem("CODCAMPAIGN")
			) {
				const id_league = localStorage.getItem("IDLEAGUE");
				const cod_campaign = localStorage.getItem("CODCAMPAIGN");

				path = `/carregando-portal/${investor.token}/campanha/${cod_campaign}/liga/${id_league}`;
			}

			window.location.href = getPath(path);
		} else {
			let errorMessage = response.errorMessage ? response.errorMessage : response.message;
			toast.error(errorMessage);
		}
	} catch (err) {
		console.error(err);
		// toast.error('Não foi possivel efetuar o login via QR Code.');
	}
}

export function* doTokenLoginExternalToken({ payload }) {
	try {
		const { token } = payload;
		let response = yield HttpService.loginUsingExternalToken(token);
		if (response.success) {
			const { investor, multiBroker, billingStatus } = response.result;
			investor["type"] = "FREE";
			if (localStorage.getItem("CLIENT_AUTH")) {
				localStorage.removeItem("CLIENT_AUTH");
			}
			sessionStorage.setItem("CLIENT_AUTH", JSON.stringify(investor));
			sessionStorage.setItem("HAS_MULTIBROKER", multiBroker.length);
			sessionStorage.setItem("TOKEN", investor.token);
			sessionStorage.setItem("PACK", JSON.stringify(billingStatus));
			sessionStorage.setItem("IDKEY", investor.id_investor.toString());
			const homePortalPath = "/carregando-portal/" + investor.token + "/league";
			let path = !investor.is_password_defined ? "/redefinir-senha" : homePortalPath;

			// if(investor.is_password_defined && localStorage.getItem('IDLEAGUE') && localStorage.getItem('CODCAMPAIGN')){
			//     const id_league = localStorage.getItem("IDLEAGUE")
			//     const cod_campaign = localStorage.getItem("CODCAMPAIGN")

			//     path = `/carregando-portal/${investor.token}/campanha/${cod_campaign}/liga/${id_league}`
			// }

			window.location.href = getPath(path);
		} else {
			let errorMessage = response.errorMessage ? response.errorMessage : response.message;
			toast.error(errorMessage);
			window.location.href = getPath("/carregando-portal/" + token + "/league");
		}
	} catch (err) {
		console.error(err);
	}
}

export function* authenticateAuthToken({ payload }) {
	try {
		const { auth_token } = payload;
		yield HttpService.authorizeAuthToken(auth_token, "992ce70750d206e177ccbdd73519e924");
	} catch (err) {
		toast.error("Não foi possivel efetuar o login via QR Code.");
	}
}

export default all([
	takeLatest("@qrCode/GENERATE_QR_CODE_REQUEST", generateQrCode),
	takeLatest("@qrCode/VERIFY_PROCESS_REQUEST", verifyProcess),
	takeLatest("@qrCode/PROCCESS_QR_CODE_LOGIN_REQUEST", proccessQrCodeLogin),
	takeLatest("@qrCode/DO_TOKEN_LOGIN_REQUEST", doTokenLogin),
	takeLatest("@qrCode/AUTHORIZE_AUTH_TOKEN_REQUEST", authenticateAuthToken),
	takeLatest("@qrCode/DO_TOKEN_LOGIN_REQUEST_EXTERNAL_TOKEN", doTokenLoginExternalToken),
]);
